module.exports = __webpack_public_path__ + "static/assets/bc09254bad2ea75ab8b5d646e9fa1207.svg";